module.exports = __webpack_public_path__ + "static/img/12.0afb020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/eng/12.png
// module id = fw/I
// module chunks = 0